import { render, staticRenderFns } from "./informacion.vue?vue&type=template&id=2580b25c&scoped=true&"
import script from "./informacion.vue?vue&type=script&lang=js&"
export * from "./informacion.vue?vue&type=script&lang=js&"
import style0 from "./informacion.vue?vue&type=style&index=0&id=2580b25c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580b25c",
  null
  
)

export default component.exports